// mixin
export default {
  data() {
    return {};
  },
  methods: {
    /**
     * @Description 金额显示 精度控制 + 千分位分隔,无值显示“--”
     * @date 2024/2/4
     * @param {any} num 金额,必须
     * @param {number} digit 小数位数,可选
     * @return {string}
     */
    mixinAmountDisplay(num, digit = -1) {
      let returnStr = "--";

      if (num) {
        if (digit >= 0) {
          returnStr = this.$thousandSeparator(num, digit);
        } else {
          returnStr = this.$thousandSeparator(num);
        }
      }

      return returnStr;
    }
  }
};